import { Markdown } from "PFComponents/markdown/markdown";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useTranslation } from "react-i18next";

import css from "./markdown_input_with_preview.module.scss";

type MarkdownInputWithPreviewProps = {
  value: string;
  setValue: (value: string) => void;
  label: string;
};

export const MarkdownInputWithPreview = ({ value, setValue, label }: MarkdownInputWithPreviewProps) => {
  const { t } = useTranslation("saasAdmin");

  return (
    <div className={css.markdownInput}>
      <InputFieldSet
        label={label}
        onChange={setValue}
        value={value || ""}
        tip={`
        ${t("leaveEmptyToHide")}\n
        ${t("markdownTips.title")}\n
        ${t("markdownTips.subtitle")}\n
        ${t("markdownTips.italics")}\n
        ${t("markdownTips.bold")}\n
        ${t("markdownTips.img")}
      `}
        inputType="textarea"
      />
      <div className={css.markdownInputPreview}>
        <h3>Preview</h3>
        <div>
          <Markdown raw={value} emojify={false} />
        </div>
      </div>
    </div>
  );
};
